import { Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  currentYear: number = new Date().getFullYear();

  navigateToOnboard(): void {
    const onboardUrl = environment.appUrls?.onboard || 'https://onboard.chareety.com';
    window.open(`${onboardUrl}?source=marketing`, '_blank');
  }
}
